import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { SectionSummary } from './section-summary';
import { PreviousSectionId } from './section';
export var SectionSummaries = /*#__PURE__*/function () {
  function SectionSummaries() {
    _classCallCheck(this, SectionSummaries);
  }

  _createClass(SectionSummaries, null, [{
    key: "sortSections",
    value: function sortSections(sections) {
      var sortedSections = [];
      var headSection = sections.find(function (section) {
        return section.previousSectionId.toString() === PreviousSectionId.None;
      });
      sortedSections.push(headSection);
      var currentSectionId = headSection.id.toString();
      sections.forEach(function () {
        var nextSection = sections.find(function (section) {
          return section.previousSectionId.toString() === currentSectionId;
        });

        if (!nextSection) {
          return;
        }

        sortedSections.push(nextSection);
        currentSectionId = nextSection === null || nextSection === void 0 ? void 0 : nextSection.id.toString();
      });
      return sortedSections;
    }
  }, {
    key: "updateSectionSummaries",
    value: function updateSectionSummaries(sectionSummaries, changedSection) {
      var newSection = SectionSummary.createFromSection(changedSection);
      var result = sectionSummaries.map(function (sectionSummary) {
        if (sectionSummary.id.toString() === newSection.id.toString()) {
          return newSection;
        }

        return sectionSummary;
      });
      return result;
    }
  }, {
    key: "cloneTo",
    value: function cloneTo(sections) {
      var clonedSectionSummarys = sections.map(function (s) {
        return SectionSummary.cloneTo(s);
      });
      return clonedSectionSummarys;
    }
  }, {
    key: "insertSectionSummaryToSectionSummaries",
    value: function insertSectionSummaryToSectionSummaries(input) {
      var newSectionSummary = input.newSectionSummary,
          sectionSummaries = input.sectionSummaries;

      if (sectionSummaries.length === 0) {
        return [newSectionSummary];
      }

      var updatedSectionSummaries = [].concat(_toConsumableArray(sectionSummaries), [newSectionSummary]);
      var nextSectionSummary; // insert into head of sectionSummaries

      if (newSectionSummary.previousSectionId === 'none') {
        nextSectionSummary = sectionSummaries.find(function (s) {
          return s.previousSectionId === 'none';
        });
      } else {
        // insert in the middle of sectionSummaries
        nextSectionSummary = sectionSummaries.find(function (s) {
          return s.previousSectionId === newSectionSummary.previousSectionId;
        });
      }

      if (!nextSectionSummary) {
        return updatedSectionSummaries;
      }

      nextSectionSummary.updatePreviousSectionId(newSectionSummary.id.toString());
      var result = SectionSummaries.sortSections(updatedSectionSummaries);
      return result;
    }
  }, {
    key: "deleteSectionSummary",
    value: function deleteSectionSummary(sectionId, sectionSummaries) {
      var deletedIndex = sectionSummaries.findIndex(function (section) {
        return section.id.toString() === sectionId;
      });
      var deletedSection = sectionSummaries[deletedIndex];
      var nextSection = sectionSummaries[deletedIndex + 1];

      if (deletedSection.previousSectionId) {
        nextSection === null || nextSection === void 0 ? void 0 : nextSection.updatePreviousSectionId(deletedSection.previousSectionId);
      }

      var sectionSummariesUpdate = sectionSummaries.filter(function (section) {
        return section.id.toString() !== sectionId;
      });
      return sectionSummariesUpdate;
    }
  }, {
    key: "toSectionSummaries",
    value: function toSectionSummaries(sections) {
      return sections.map(function (section) {
        return SectionSummary.createFromSection(section);
      });
    }
  }, {
    key: "addNewSectionToSectionSummaries",
    value: function addNewSectionToSectionSummaries(sectionSummaries, newSection) {
      var newSectionSummary;

      if (newSection) {
        newSectionSummary = SectionSummary.createFromSection(newSection);
      }

      var newSectionSummaries = SectionSummaries.insertSectionSummaryToSectionSummaries({
        newSectionSummary: newSectionSummary,
        sectionSummaries: sectionSummaries
      });
      return newSectionSummaries;
    }
  }]);

  return SectionSummaries;
}();